import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;
  levelValue: string;
  handleLevel: (e: string) => void;
  handleUpdateActive: (e: { value: string | number; label: string }[]) => void;
  selectedActive: { value: string | number; label: string }[];
  handleUpdateType: (e: { value: string | number; label: string }[]) => void;
  selectedType: { value: string | number; label: string }[];
  handleApply: () => void;
}
const CashbacksFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,
  levelValue,
  handleLevel,
  handleUpdateActive,
  selectedActive,
  handleUpdateType,
  selectedType,
  handleApply,
}) => {
  const { t } = useTranslation();

  const handleApplyActive = (
    e: { value: string | number; label: string }[]
  ) => {
    handleUpdateActive(e);
  };
  const handleApplyType = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateType && selectedType)
      handleUpdateType(isDelete ? e : [...selectedType, ...e]);
  };

  const handleClearFilters = () => {
    handleSearch("");
    handleLevel("");
    handleApplyType([]);
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      className="cashbacks-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
        },
        {
          type: FilterItemTypes.input,
          title: t("level"),
          boxTitle: t("level"),
          icon: gridIcon,
          inputValue: levelValue,
          setInputValue: handleLevel,
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: selectedActive,
          handleApply: handleApplyActive,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("type"),
          boxTitle: t("type"),
          icon: gridIcon,
          activeItems: selectedType,
          handleApply: handleApplyType,
          itemsArray: [
            {
              value: "hourly",
              label: t("hourly"),
            },
            {
              value: "daily",
              label: t("daily"),
            },
            {
              value: "weekly",
              label: t("weekly"),
            },
            {
              value: "monthly",
              label: t("monthly"),
            },
            {
              value: "yearly",
              label: t("yearly"),
            },
          ],
        },
      ]}
    />
  );
};

export default CashbacksFilter;
